import { render, staticRenderFns } from "./MarketsCurrencyPairs.vue?vue&type=template&id=25836720&scoped=true&"
import script from "./MarketsCurrencyPairs.vue?vue&type=script&lang=js&"
export * from "./MarketsCurrencyPairs.vue?vue&type=script&lang=js&"
import style0 from "./MarketsCurrencyPairs.vue?vue&type=style&index=0&id=25836720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25836720",
  null
  
)

export default component.exports